import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/operated/comment/getComment/new/:id',
    owner: '/home',
    authority: 'getCommentMessageItemDetail',
    component: Loadable({
      loader: () => import('./Edit'),
      loading: () => <RouteLoading />
    })
  }
];